import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { BoardsDialogComponent } from '../boards-dialog/boards-dialog.component';
import { SetupAccountComponent } from '@app-shared/components/setup-account/setup-account.component';
import { ExamDialogComponent } from '../exam-dialog/exam-dialog.component';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { updateUser, successOpen } from '@app-modules/feature/editprofile/editprofile.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from '@app-services/user/user.service';

@Component({
  selector: 'app-gradesdialog',
  templateUrl: './gradesdialog.component.html',
  styleUrls: ['./gradesdialog.component.css']
})
export class GradesdialogComponent implements OnInit {
  grades: any = [];
  streams:any = [];
  selectedGrade: any;
  isSelected: boolean = false;
  selectedStream = '';
  constructor(private dialogRef: MatDialogRef<GradesdialogComponent>,
    private dialog: MatDialog, private _formBuilder: FormBuilder, private gaService: GAnalyticsService,
    @Inject(MAT_DIALOG_DATA) public data: any, private gradesService: BoardsService,
    public router: Router, private spinner: NgxSpinnerService, 
    private userService: UserService
  ) {
    this.data.isGradeEdit = this.data.isGradeEdit || this.data.setupAccountImposed;
      dialogRef.disableClose = !this.data.isGradeEdit;
  }

  ngOnInit(): void {
    //console.log('dialog data', this.data);
    if (this.data.selectedStream) {
      this.selectedStream = this.data.selectedStream;
    }

    this.getGrades();
    this.getStreams();
  }
  getStreams() {
    this.gradesService.fetchStreamsList().subscribe((data:any) => {
      this.streams = data;
    })
  }
  getGrades() {
    this.gradesService.fetchGradesList().subscribe((data: any) => {
      const grades = data;
      
      grades.sort((a: any, b: any) => {
        return Number(a.name.replaceAll(/[^0-9]/g, "")) - Number(b.name.replaceAll(/[^0-9]/g, ""));
      })
        for(let i =0, len = grades.length; i< len; i++ ) 
        {
          if(grades[i].name == "9th" || grades[i].name == "10th" || grades[i].name == "11th" || grades[i].name == "12th" || grades[i].name == "13th") {
            this.grades[this.grades.length] = grades[i];
          }
          if(grades[i].name == this.data?.grade?.name) {
            this.selectedGrade = grades[i];
          }
        }
    });
  }

  saveIndex(gr: any, isGradeEdit: boolean=false) {
    this.selectedGrade = gr;
    // if (gr.name=='11th' || gr.name=='12th' || gr.name=='13th') {
      
    // } else {
    //   this.selectedStream = '';
    //   if (!isGradeEdit) this.grade();
    // }
    if (gr.name=='9th' || gr.name=='10th' || gr.name=='11th' || gr.name=='12th' || gr.name=='13th') {
      this.selectedStream = '';
      if (!isGradeEdit || this.data.setupAccountImposed) this.grade();
    }
  }

  grade() {
    this.dialogRef.close();
    //this.openboards(this.index);
    this.openexams();
  }

  onConfirmClick() {

    if (this.data.isGradeEdit && (this.selectedGrade != undefined || this.selectedGrade != null)) {
      if ((this.selectedGrade?.name=='11th' || this.selectedGrade?.name=='12th' || this.selectedGrade?.name=='13th') && !this.selectedStream) return;
      if(this.data.setupAccountImposed) {
        this.grade();
      } else {
        let data = {
          grade: this.grades.find((grade: any) => grade.name == this.selectedGrade.name),
          stream:this.streams.find((stream: any) => stream.streamId == this.selectedStream)
        }
        updateUser.call(this, [{name: 'grade', value: data.grade}, {name: 'stream', value: data.stream}], () => {
          successOpen.call(this, 'Profile Updated' ,`Your grade has been updated  successfully`, () => this.dialogRef.close(data))
        })
        
      }    
    }
    // else {
    //   this.dialogRef.close();
    // }
  }
  onStreamClick(stream: any) {
    this.selectedStream = stream;
    if (!this.data.isGradeEdit) {
      this.grade();
    }
    
  }
  onNoClick(): void {
    this.dialog.closeAll();
  }

  openboards(i: any) {
    const config: MatDialogConfig = {
      maxWidth:"570px",
      //height: '100%',
      panelClass:'mat-full',
      //panelClass:'openboards-full',
      data: {
        message: 'What board are you enrolled in?', message2: `If you can’t find it in the list, enter in the search box`,
        accountDetails: this.data.accountDetails, grade: this.grades.find((grade:any)=>grade.name==this.selectedGrade.name),
        selectedStream:this.selectedStream,
        actionData: this.data?.actionData
      }
    };
    const dialogRef = this.dialog.open(BoardsDialogComponent, config);
  }

  openexams() {
    console.log(this.data);
    let user = JSON.parse(localStorage.getItem('mobile_and_name'));
    this.gaService.sendEvent(
      'Grade Selected (Setup Account )',
      '',
      '',
      '',
      { 
        'event': 'Grade Selected (Setup Account )' ,
        'Phone Number': user?.phone,
        'First Name':  user?.firstName,
        'Last Name': user?.lastName,
        'City': '',
        'Email ID': this.data?.accountDetails?.email,
        'Grade': this.selectedGrade?.name,
      }
    )
    const config: MatDialogConfig = {
      maxWidth:"570px",
      //height: '100%',
      panelClass:'mat-full',
      data: {
        message: 'What exams are you targeting?', message2: `Select as many. If you can’t find it in the list, enter in the search box`,
        accountDetails: this.data.accountDetails, grade: this.grades.find((grade:any)=>grade.name==this.selectedGrade.name),
        selectedStream:this.selectedStream,
        board: null,
        actionData: this.data?.actionData,
        setupAccountImposed: this.data.setupAccountImposed
      }
    };
    const dialogRef = this.dialog.open(ExamDialogComponent, config);
  }

  showStep1() {
    this.dialogRef.close();
    const config: MatDialogConfig = {
      maxWidth:"570px",
      //height: '100%',
      panelClass:'mat-full',
      data: {
        message: 'Set Up Your Account', message2: `Please setup your account by entering your email ID and setting a password`,
        ...this.data.accountDetails,
        actionData: this.data?.actionData,
        setupAccountImposed: this.data.setupAccountImposed
      }
    };
    const dialogRef = this.dialog.open(SetupAccountComponent, config);
  }

}
